import React, { useEffect } from 'react'
import { Switch } from 'react-router-dom'

import Route from './Route'

import BemVindo from '../pages/BemVindo'
import Contribution from '../pages/Contribution'
import Simulation from '../pages/Simulation'
import Welcome from '../pages/Welcome'
import Finish from '../pages/Finish'
import Register from '../pages/Register'
import ConfirmSMS from '../pages/ConfirmSMS'
import Taxation from '../pages/Taxation'
import FatcaInfo from '../pages/FatcaInfo'
import Investor from '../pages/Investor'
import Beneficiary from '../pages/Beneficiary'
import BeneficiaryList from '../pages/BeneficiaryList'
import AportConfirmation from '../pages/AportConfirmation'
import Conclusion from '../pages/Conclusion'
import Resume from '../pages/Resume'
import Attachment from '../pages/Attachment'
import End from '../pages/End'

import Erro from '../pages/Erro'
import NotFound from '../pages/NotFound'

import { ConfigData } from '../utils/interfaces'
import usePersistedState from '../hooks/usePersistedState'
import clientConfig from '../services/clientConfig'
// import PersonalInfos from '../pages/PersonalInfos'
// import Contribuition from '../pages/Contribuition'
// import Benefit from '../pages/Benefit'
// import ConfirmOwnership from '../pages/ConfirmOwnership'
// import GoalSelection from '../pages/GoalSelection'
// import Terms from '../pages/Terms'
// import Login from '../pages/Login'
// import Help from '../pages/Help'

const Routes: React.FC = () => {
  const { codCliente, tipo, plano } = clientConfig()

  const [configData, setConfigData] = usePersistedState<ConfigData>(
    'configData',
    {} as ConfigData,
  )
  useEffect(() => {
    setConfigData({
      ...configData,
      codCliente,
      tipo,
      plano,
    })
  }, [])

  return (
    <Switch>
      <Route path="/" exact component={BemVindo} />
      <Route path="/contribution" component={Contribution} />
      <Route path="/simulation" component={Simulation} />
      <Route path="/welcome" component={Welcome} />
      <Route path="/finish" component={Finish} />
      <Route path="/register" exact component={Register} />
      <Route path="/register/confirm-sms" component={ConfirmSMS} />
      <Route path="/taxation" component={Taxation} />
      <Route path="/pep-fatca" component={FatcaInfo} />
      <Route path="/investor" component={Investor} />
      <Route path="/beneficiary" component={Beneficiary} />
      <Route path="/beneficiary-list" component={BeneficiaryList} />
      <Route path="/resume" component={Resume} />
      <Route path="/conclusion" component={Conclusion} />
      <Route path="/end" component={End} />
      <Route path="/aport-confirmation" component={AportConfirmation} />
      <Route path="/attachment" component={Attachment} />

      <Route path="/erro" component={Erro} />
      <Route path="*" component={NotFound} />
      {/* <Route path="/personal-infos" component={PersonalInfos} /> */}
      {/* <Route path="/contribuition" component={Contribuition} />
      <Route path="/benefit" component={Benefit} />
      <Route path="/goal-selection" component={GoalSelection} />
      <Route path="/help" component={Help} />
      <Route path="/confirm-ownership" component={ConfirmOwnership} />
      <Route path="/terms" component={Terms} />
      <Route path="/login" component={Login} /> */}
    </Switch>
  )
}

export default Routes
